import React from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "./AppButton.scss";

/**
 * BackButton — A standard back navigation button matching UX_DESIGNS.
 *
 * Uses ghost variant from AppButton styles. Shows an ArrowLeft icon.
 * Automatically calls navigate(-1) when no onClick is provided.
 *
 * Props:
 *   onClick   — click handler (defaults to navigate(-1))
 *   className — extra class
 *   size      — icon size in px (default: 16)
 */
const BackButton = ({ onClick, className = "", size = 16, ...props }) => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className={`app-btn app-btn--ghost app-btn--icon ${className}`}
      onClick={onClick || (() => navigate(-1))}
      aria-label="Go back"
      {...props}
    >
      <ArrowLeft size={size} />
    </button>
  );
};

export default BackButton;
